module.exports = __webpack_public_path__ + "static/media/IsimIcinLogoWhite.71298393.png";